import { Stack } from '@mui/material';

import { SearchDomain } from '../../types/SearchDomain.ts';
import { useSearchDomainConfig } from '../SearchDomainConfigProvider';

export interface SearchFiltersProps {
  domain: SearchDomain;
}

export const SearchFilters = ({ domain }: SearchFiltersProps) => {
  const { searchConfigByDomain } = useSearchDomainConfig();
  const searchConfig = searchConfigByDomain(domain);
  return (
    <Stack direction="column" spacing={4}>
      {searchConfig.filters.map(({ attribute, component: Component, componentProps }, index) => {
        return <Component key={index} attribute={attribute} {...componentProps} />;
      })}
    </Stack>
  );
};
